/**
 * @module shouldRefreshClientConfiguration
 */

import store from '../store/store';
import {
    CLIENT_CONFIGURATION_VALIDITY,
    CLIENT_CONFIGURATION_ERROR_RETRY_DELAY,
} from '../constants';
import { ClientConfigurationCacheState } from '../store/schema/clientConfigurationCache';

/**
 * @function
 * To check whether there is a need to refresh the client configuration or not
 * @returns whether the client configuration refresh is required or not
 */

const shouldRefreshClientConfiguration = (): boolean => {
    const lastFetchTimeSpan: number = Date.now() - store.cache.time;

    return (
        (store.cache.state === ClientConfigurationCacheState.Success &&
            lastFetchTimeSpan >= CLIENT_CONFIGURATION_VALIDITY) ||
        (store.cache.state === ClientConfigurationCacheState.Error &&
            lastFetchTimeSpan >= CLIENT_CONFIGURATION_ERROR_RETRY_DELAY)
    );
};

export default shouldRefreshClientConfiguration;
